<template>
  <div>
    <span v-if="1 == msg.msgType">
      <!-- 文章消息 -->
      <a target="_blank" :href="msg.msgExtend">{{ msg.msg }}</a>
    </span>
    <span v-else-if="2 == msg.msgType"> 图片消息 {{ msg.msg }} </span>
    <span v-else-if="3 == msg.msgType"> 视频消息 {{ msg.msg }} </span>
    <span v-else-if="4 == msg.msgType"> 音频消息 {{ msg.msg }} </span>
    <span v-else>
      <!-- 文本消息 -->
      {{ msg.msg }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ChatMsgItem",
  props: {
    msg: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
